import { useState, useEffect } from 'react';

const STORAGE_KEY = 'ukpc_cookie_consent';

/**
 * Simple cookie notice banner. Essential cookies don't require consent
 * under UK GDPR, but transparency is good practice.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-slate-200 shadow-lg px-4 py-4"
      role="region"
      aria-label="Cookie notice"
    >
      <div className="container-main flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-slate-700">
          This site uses essential cookies for authentication. No tracking cookies are used.
        </p>
        <button
          onClick={handleAccept}
          className="btn-secondary btn-sm self-start sm:self-auto flex-shrink-0"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
